import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InvertedAnswerBadgeComponent } from './inverted-answer-badge.component';

@NgModule({
  declarations: [InvertedAnswerBadgeComponent],
  imports: [CommonModule, NgbTooltipModule],
  exports: [InvertedAnswerBadgeComponent],
})
export class InvertedAnswerBadgeModule {}
